/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * SizeEstimate as it appears in prediction.json — written with
 * exclude_none, so every field must be optional here.
 * @export
 * @interface SubmissionEstimateDiagnostic
 */
export interface SubmissionEstimateDiagnostic {
    /**
     * 
     */
    fishPresent?: boolean | null;
    /**
     * 
     */
    estimable?: boolean | null;
    /**
     * 
     */
    lengthMm?: number | null;
    /**
     * 
     */
    girthMm?: number | null;
    /**
     * 
     */
    weightG?: number | null;
    /**
     * 
     */
    confidence?: string | null;
    /**
     * 
     */
    basis?: string | null;
}

/**
 * Check if a given object implements the SubmissionEstimateDiagnostic interface.
 */
export function instanceOfSubmissionEstimateDiagnostic(value: object): value is SubmissionEstimateDiagnostic {
    return true;
}

export function SubmissionEstimateDiagnosticFromJSON(json: any): SubmissionEstimateDiagnostic {
    return SubmissionEstimateDiagnosticFromJSONTyped(json, false);
}

export function SubmissionEstimateDiagnosticFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubmissionEstimateDiagnostic {
    if (json == null) {
        return json;
    }
    return {
        
        'fishPresent': json['fish_present'] === undefined ? undefined : json['fish_present'] === null ? null : json['fish_present'],
        'estimable': json['estimable'] === undefined ? undefined : json['estimable'] === null ? null : json['estimable'],
        'lengthMm': json['length_mm'] === undefined ? undefined : json['length_mm'] === null ? null : json['length_mm'],
        'girthMm': json['girth_mm'] === undefined ? undefined : json['girth_mm'] === null ? null : json['girth_mm'],
        'weightG': json['weight_g'] === undefined ? undefined : json['weight_g'] === null ? null : json['weight_g'],
        'confidence': json['confidence'] === undefined ? undefined : json['confidence'] === null ? null : json['confidence'],
        'basis': json['basis'] === undefined ? undefined : json['basis'] === null ? null : json['basis'],
    };
}

export function SubmissionEstimateDiagnosticToJSON(json: any): SubmissionEstimateDiagnostic {
    return SubmissionEstimateDiagnosticToJSONTyped(json, false);
}

export function SubmissionEstimateDiagnosticToJSONTyped(value?: SubmissionEstimateDiagnostic | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fish_present': value['fishPresent'],
        'estimable': value['estimable'],
        'length_mm': value['lengthMm'],
        'girth_mm': value['girthMm'],
        'weight_g': value['weightG'],
        'confidence': value['confidence'],
        'basis': value['basis'],
    };
}

